import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Icon } from "@/utils/icons";

export const ServiceCard = ({ service }) => (
  <article
    className="group flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-navy-200 hover:shadow-xl"
    data-testid={`service-card-${service.slug}`}
  >
    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-navy-50 text-navy-800 transition-colors duration-300 group-hover:bg-navy-800 group-hover:text-white">
      <Icon name={service.icon} className="h-6 w-6" aria-hidden="true" />
    </span>
    <h3 className="mt-5 font-heading text-lg font-semibold text-navy-900">{service.name}</h3>
    <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{service.short}</p>
    <Link
      to={`/services/${service.slug}`}
      className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-600 transition-colors hover:text-emerald-700"
      data-testid={`service-card-link-${service.slug}`}
    >
      Learn more <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
    </Link>
  </article>
);
